import { useState } from 'react';

import TabBaseProps from './type';
import { TabItemStyled, TabWrapperStyled } from './styled';

const Tabs = ({ ...props }: TabBaseProps) => {
  const { tabs, currentTab: currentTabProp, onChange, itemStyle, size, ...rest } = props;
  const [currentTab, setCurrentTab] = useState(currentTabProp);

  const handleClick = (value: string) => {
    setCurrentTab(value);
  };

  return (
    <TabWrapperStyled size={size} tabs={tabs} {...rest}>
      {tabs.map((tabItem, index) => {
        const { value, label } = tabItem;
        const defaultLabel = label || value || '';
        return (
          <TabItemStyled
            key={`${defaultLabel}-${index}`}
            currentTab={currentTab}
            label={defaultLabel}
            name={defaultLabel}
            size={size}
            style={itemStyle}
            onClick={(e) => {
              if (defaultLabel === currentTab) return;
              onChange(e);
              handleClick(defaultLabel);
            }}
            {...tabItem}
          >
            {defaultLabel}
          </TabItemStyled>
        );
      })}
    </TabWrapperStyled>
  );
};

export default Tabs;
